var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useContext } from 'react';
import { RadioGroupContext } from './RadioGroupContext';
export const useRadioGroup = () => {
    _react_refresh_temp_1();
    const [data, setData] = useContext(RadioGroupContext);
    const setRadioGroupValue = useCallback((value) => {
        setData((prev) => ({
            ...prev,
            value,
        }));
    }, [setData]);
    return { radioGroupData: data, setRadioGroupValue };
};
_react_refresh_temp_1(useRadioGroup, "OEWjXlOFfKUfakCoYIsdFDYQs0U=");
